export var WeaponType;
(function (WeaponType) {
    WeaponType["FIXED"] = "Fixed";
    WeaponType["GIMBAL"] = "Gimballed";
    WeaponType["TURRET"] = "Turret";
})(WeaponType || (WeaponType = {}));
export var WeaponSize;
(function (WeaponSize) {
    WeaponSize[WeaponSize["SMALL"] = 1] = "SMALL";
    WeaponSize[WeaponSize["MEDIUM"] = 2] = "MEDIUM";
    WeaponSize[WeaponSize["LARGE"] = 3] = "LARGE";
    WeaponSize[WeaponSize["HUGE"] = 4] = "HUGE";
})(WeaponSize || (WeaponSize = {}));
